import React from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import {Navigate, Route, Routes} from 'react-router-dom'
import {GenresListPage} from "./GenresListPage";
import {GenreAddPage} from "./GenreAddPage";
import {GenreEditPage} from "./GenreEditPage";

const GenresWrapper = () => {
  const intl = useIntl()
  return (
    <>
      <Routes>

        <Route
          path='/liste'
          element={
            <>
              <PageTitle breadcrumbs={[
                {
                  title: 'Paramètres',
                  path: '#',
                  isSeparator: false,
                  isActive: true,
                }
              ]}>Genres</PageTitle>
              <GenresListPage />
            </>
          }
        />
        <Route
          path='/ajouter'
          element={
            <>
              <PageTitle breadcrumbs={[
                { title: 'Paramètres', path: '#', isSeparator: false, isActive: false },
                { title: 'Genres', path: '/genres', isSeparator: false, isActive: true },
              ]}>Création</PageTitle>
              <GenreAddPage />
            </>
          }
        />
        <Route
          path=':genreId/modifier'
          element={
            <>
              <PageTitle breadcrumbs={[
                { title: 'Paramètres', path: '#', isSeparator: false, isActive: false },
                { title: 'Genres', path: '/genres', isSeparator: false, isActive: true },
              ]}>Modification</PageTitle>
              <GenreEditPage />
            </>
          }
        />
        <Route index element={<Navigate to='/genres/liste' />} />
      </Routes>
    </>
  )
}

export {GenresWrapper}
